<script setup lang="ts">
import { useNuxtApp } from "#app";
import { ResizeType } from "@bitpatty/imgproxy-url-builder";

const props = defineProps({
    title: String,
    subTitle: String,
    price: Number,
    oldPrice: Number,
    pictureUrl: String,
    detailUrl: String,
    buyUrl: String,
    skeleton: Boolean,
    notLazyLoad: Boolean,
    targetBlank: Boolean,
});
const nuxtApp = useNuxtApp();
</script>

<template>
    <nuxt-link v-if="skeleton === false" :to="detailUrl" :target="targetBlank ? '_blank' : ''" class="block grow space-y-2">
        <p class="text-sm truncate">{{ title }}</p>
        <picture v-if="pictureUrl" class="block relative">
            <source media="(max-width: 766px)" type="image/webp" :srcset="`${nuxtApp.imgProxyResize(pictureUrl, 100, 67, 'webp')} 1x, ${nuxtApp.imgProxyResize(pictureUrl, 200, 134, 'webp')} 2x`">
            <source media="(max-width: 766px)" :srcset="`${nuxtApp.imgProxyResize(pictureUrl, 100, 67)} 1x, ${nuxtApp.imgProxyResize(pictureUrl, 200, 134)} 2x`">
            <source media="(min-width: 767px)" type="image/webp" :srcset="`${nuxtApp.imgProxyResize(pictureUrl, 100, 67, 'webp')} 1x, ${nuxtApp.imgProxyResize(pictureUrl, 200, 134, 'webp')} 2x`">
            <source media="(min-width: 767px)" :srcset="`${nuxtApp.imgProxyResize(pictureUrl, 100, 67)} 1x, ${nuxtApp.imgProxyResize(pictureUrl, 200, 134)} 2x`">
            <img
                :loading="notLazyLoad ? 'eager' : 'lazy'"
                width="115"
                height="42"
                class="w-full h-[67px] object-contain object-center rounded"
                :src="nuxtApp.imgProxyResize(pictureUrl, 100, 67)"
                :alt="title"
            >
        </picture>
        <p :class="{'text-red-600': oldPrice}" class="leading-none font-bold text-center">
            <PartPriceExtend
                :price="price"
                currencyClass="text-sm leading-none align-baseline"
                pricePart1Class="font-bold text-xl leading-none align-baseline"
                pricePart2Class="text-sm leading-none align-baseline"
            />
            <span v-if="oldPrice" class="block text-gray-500">
                    <PartPriceExtend
                        :price="oldPrice"
                        currencyClass="text-xs leading-none align-baseline"
                        pricePart1Class="font-bold text-sm leading-none align-baseline line-through decoration-red-600"
                        pricePart2Class="text-xs leading-none align-baseline"
                    />
                </span>
        </p>
    </nuxt-link>
    <div v-else class="flex flex-col bg-gray-50 p-4 sm:p-6 rounded-lg space-y-2 md:space-y-4 h-full">
        <div class="animate-pulse rounded h-4 w-[70%] bg-gray-100"></div>
        <div class="space-y-2">
            <div class="animate-pulse rounded h-2 w-[40%] bg-gray-100"></div>
            <div class="animate-pulse rounded h-2 w-[80%] bg-gray-100"></div>
            <div class="animate-pulse rounded h-2 w-[60%] bg-gray-100"></div>
        </div>
        <picture class="block relative mb-6">
            <div class="animate-pulse h-20 sm:h-40 w-full object-center rounded bg-soft-white-100"></div>
        </picture>
        <div class="animate-pulse rounded h-4 w-[70%] bg-gray-100"></div>
    </div>
</template>